<template>
	<div id="departments">
		<el-breadcrumb style="margin-left: 20px;margin-bottom: 10px;margin-top: 20px;">
		</el-breadcrumb>
		<!-- 第一页 -->
		<el-form size="mini" ref="form" label-width="200px" v-if="!showTable">
			<div class="page1" v-for="item in page_one" :model="page_one_data" :key="item.index">
				<div v-show="item.required">
					<el-form-item :label="item.name + ':'" :required="item.required" v-if="item.uiType == 1">
						<el-input :style="input_width" v-model="page_one_data[item.id]"></el-input>
					</el-form-item>
				</div>

				<div v-show="item.required">
					<el-form-item :label="item.name + ':'" :required="item.required" v-if="item.uiType == 2">
						<el-input type="textarea" :style="input_width" :disabled="item.editable"
							v-model="page_one_data[item.id]"></el-input>
					</el-form-item>
				</div>

				<div v-show="item.required">
					<el-form-item :label="item.name + ':'" v-if="item.uiType == 3" :required="item.required">
						<el-select v-model="page_one_data_select[item.id]" :placeholder="$t('message.placeholder.select')"
							:style="input_width" :disabled="item.editable">
							<el-option v-for="items in item.listEntrie" :label='items.name' :value="items.id" :key="items.index">
							</el-option>
						</el-select>
					</el-form-item>
				</div>

				<div v-show="item.required">
					<el-form-item :label="item.name + ':'" v-if="item.uiType == 4" :required="item.required">
						<el-select v-model="page_one_data_select[item.id]" :placeholder="$t('message.placeholder.select')"
							:style="input_width" :disabled="item.editable" multiple>
							<el-option v-for="items in item.listEntrie" :label='items.name' :value="items.id" :key="items.index">
							</el-option>
						</el-select>
					</el-form-item>
				</div>

				<div v-show="item.required">
					<el-form-item :label="item.name + ':'" v-if="item.uiType == 6" :required="item.required">
						<el-date-picker :style="input_width" v-model="page_one_data[item.id]" type="datetime"
							:placeholder="$t('message.placeholder.pickDate')">
						</el-date-picker>
					</el-form-item>
				</div>
			</div>



			<!-- 第二页 -->
			<!-- <span style="margin: 0 30px;padding: 0;font-size: 12;color: #000;">PageTwo</span>
			<div style="border-top: 1px solid #f1f1f1;margin: 10px 10px 20px 10px;"></div>-->
			<div class="page2" v-for="item in page_two" :model="page_two_data" :key="item.index">
				<div v-show="item.required">
					<el-form-item :label="item.name + ':'" :required="item.required" v-if="item.uiType == 1">
						<!-- <el-input :style="input_width" :disabled="item.required"></el-input> -->
						<el-input :style="input_width" v-model="page_two_data[item.id]"></el-input>
					</el-form-item>
				</div>

				<div v-show="item.required">
					<el-form-item :label="item.name + ':'" :required="item.required" v-if="item.uiType == 2">
						<el-input type="textarea" :style="input_width" :disabled="item.editable"
							v-model="page_two_data[item.id]"></el-input>
					</el-form-item>
				</div>

				<div v-show="item.required">
					<el-form-item :label="item.name + ':'" v-if="item.uiType == 3" :required="item.required">
						<el-select v-model="page_two_data_select[item.id]" :placeholder="$t('message.placeholder.select')"
							:style="input_width" :disabled="item.editable">
							<el-option :label='items.name' :value="items.id" v-for="items in item.listEntrie" :key="items.index">
							</el-option>
						</el-select>
					</el-form-item>
				</div>

				<div v-show="item.required">
					<el-form-item :label="item.name + ':'" v-if="item.uiType == 4" :required="item.required">
						<el-select v-model="page_two_data_select[item.id]" :placeholder="$t('message.placeholder.select')"
							:style="input_width" :disabled="item.editable" multiple>
							<el-option :label='items.name' :value="items.id" v-for="items in item.listEntrie" :key="items.index">
							</el-option>
						</el-select>
					</el-form-item>
				</div>

				<div v-show="item.required">
					<el-form-item :label="item.name + ':'" v-if="item.uiType == 6" :required="item.required">
						<el-date-picker :style="input_width" v-model="page_two_data[item.id]" type="datetime"
							:placeholder="$t('message.placeholder.pickDate')">
						</el-date-picker>
					</el-form-item>
				</div>
			</div>

			<!-- 第三页 -->
			<!-- <span style="margin: 0 30px;padding: 0;font-size: 12;color: #000;">PageThree</span>
			<div style="border-top: 1px solid #f1f1f1;margin: 10px 10px 20px 10px;"></div> -->
			<div class="page2" v-for="item in page_three" :model="page_three_data" :key="item.index">
				<div v-show="item.required">
					<el-form-item :label="item.name + ':'" :required="item.required" v-if="item.uiType == 1">
						<!-- <el-input :style="input_width" :disabled="item.required"></el-input> -->
						<el-input :style="input_width" v-model="page_three_data[item.id]"></el-input>
					</el-form-item>
				</div>

				<div v-show="item.required">
					<el-form-item :label="item.name + ':'" :required="item.required" v-if="item.uiType == 2">
						<el-input type="textarea" :style="input_width" :disabled="item.editable"
							v-model="page_three_data[item.id]"></el-input>
					</el-form-item>
				</div>

				<div v-show="item.required">
					<el-form-item :label="item.name + ':'" v-if="item.uiType == 3" :required="item.required">
						<el-select v-model="page_three_data_select_1[item.id]" :placeholder="$t('message.placeholder.select')"
							:style="input_width" :disabled="item.editable">
							<el-option :label='items.name' :value="items.id" v-for="items in item.listEntrie" :key="items.index">
							</el-option>
						</el-select>
					</el-form-item>
				</div>

				<div v-show="item.required">
					<el-form-item :label="item.name + ':'" v-if="item.uiType == 4" :required="item.required">
						<el-select v-model="page_three_data_select[item.id]" :placeholder="$t('message.placeholder.select')"
							:style="input_width" :disabled="item.editable" multiple>
							<el-option :label='items.name' :value="items.id" v-for="items in item.listEntrie" :key="items.index">
							</el-option>
						</el-select>
					</el-form-item>
				</div>

				<div v-show="item.required">
					<el-form-item :label="item.name + ':'" v-if="item.uiType == 6" :required="item.required">
						<el-date-picker :style="input_width" v-model="page_three_data[item.id]" type="datetime"
							:placeholder="$t('message.placeholder.pickDate')">
						</el-date-picker>
					</el-form-item>
				</div>
			</div>

			<el-form-item>
				<el-button type="primary" @click="submitForm">{{ $t('message.button.createNow') }}</el-button>
				<el-button @click="reset">{{ $t('message.button.reset') }}</el-button>
				<!-- <el-button type="primary" @click="CreateNext">保存并创建下一个用户组</el-button> -->
			</el-form-item>
		</el-form>

	</div>
</template>

<style scoped>
.create-list {
	padding: 0;
	margin: 0;
	overflow: hidden;
	margin-bottom: 30px;
}

.create-list-subClass {
	width: 24%;
	height: 30px;
	float: left;
	text-align: center;
	background: #ebeef5;
	margin-right: 1%;
	margin-top: 10px;
	line-height: 30px;
}

.create-list-subClass:hover {
	cursor: pointer;
	background: #409eff;
	color: #fff;
}

.create-list .create-list-class {
	width: 96%;
	background: rgb(198, 226, 255);
	text-align: left;
	height: 38px;
	line-height: 38px;
	font-size: 18px;
	cursor: default;
	padding-left: 3%;
}
</style>

<script>
import axios from "axios";
export default {
	data() {
		return {
			loading: true,
			loginPwd: "",
			loginPwdAgain: "",
			classId_: "",
			//pageInfoObj:{},
			page_one_data_select: {}, //多选
			page_two_data_select: {},
			page_three_data_select: {},

			page_one_data_select_1: {}, //单选
			page_two_data_select_1: {},
			page_three_data_select_1: {},
			classId: "",
			page_one: [], //
			page_one_data: {},

			page_two: [], //
			page_two_data: {},

			page_three: [], //
			page_three_data: {},

			type_: "",

			loading: true,
			show: true,
			show2: true,
			show3: true,
			show4: true,

			showTable: true, //创建首页显示
			input_width: {
				width: "50%"
			},

			rules: {
				region: [{
					required: true,
					// message: '请选择活动区域',
					trigger: 'change'
				}],
			}
		};
	},
	props: ['pageInfo'],
	methods: {
		selectOne(event, item) { //change 触发事件
			//直接就拿到当前的这个对象了
			this.ruleForm.name = event;
			this.sizeForm.name = event;
		},
		listClick: function () {
			//alert("1");
			//console.log(this.ruleForm.region);
		},
		submitForm() {
			// this.$emit('buttonClick','ffff')
			var vm = this;
			var pg1 = this.page_one_data;
			var pg2 = this.page_two_data;
			var pg3 = this.page_three_data;
			pg1.classId = this.classId_;

			// if (this.page_one_data_select[1092002] = this.pageInfo) {
			// this.page_one_data_select[1092002] = 100
			// }
			var arr1 = this.page_one_data_select;
			var arr2 = this.page_two_data_select;
			var arr3 = this.page_three_data_select;

			var arr1_1 = this.page_one_data_select_1;
			var arr2_1 = this.page_two_data_select_1;
			var arr3_1 = this.page_three_data_select_1;

			// if (this.pageInfo.indexOf(pg1[1092001]) != -1 ) {
			// 	this.$message.error('该用户组已存在');
			// 	return false;
			// }

			// if (this.loginPwd !== this.loginPwdAgain) {
			// 	this.$message.error('密码输入不一致');
			// 	return false;
			// };
			//console.log(arr);
			for (var key in arr1) { //将下拉菜单输出格式s数组为对象
				var val = arr1[key];
				var str = "";
				for (var i = 0; i < val.length; i++) {
					str += val[i] + ";";
				};
				if (str.length > 0) {
					str = str.substr(0, str.length - 1);
				};
				if (str.length != 0) {
					pg1[key] = str + "";
				} else { };
			};
			for (var key in arr2) {
				var val = arr2[key];
				var str = "";
				for (var i = 0; i < val.length; i++) {
					str += val[i] + ";";
				};
				if (str.length > 0) {
					str = str.substr(0, str.length - 1);
				};
				if (str.length != 0) {
					pg2[key] = str + "";
				} else { };
			};
			for (var key in arr3) {
				var val = arr3[key];
				var str = "";
				for (var i = 0; i < val.length; i++) {
					str += val[i] + ";";
				};
				if (str.length > 0) {
					str = str.substr(0, str.length - 1);
				};
				if (str.length != 0) {
					pg3[key] = str + "";
				} else { };
			};
			for (var key in arr1_1) {
				var val = arr1_1[key];
				var str = "";
				for (var i = 0; i < val.length; i++) {
					str += val[i] + ";";
				};
				if (str.length > 0) {
					str = str.substr(0, str.length - 1);
				};
				if (str.length != 0) {
					pg1[key] = str + "";
				} else { };
			};
			for (var key in arr2_1) {
				var val = arr2_1[key];
				var str = "";
				for (var i = 0; i < val.length; i++) {
					str += val[i] + ";";
				};
				if (str.length > 0) {
					str = str.substr(0, str.length - 1);
				};
				if (str.length != 0) {
					pg2[key] = str + "";
				} else { };
			};
			for (var key in arr3_1) {
				var val = arr3_1[key];
				var str = "";
				for (var i = 0; i < val.length; i++) {
					str += val[i] + ";";
				};
				if (str.length > 0) {
					str = str.substr(0, str.length - 1);
				};
				if (str.length != 0) {
					pg3[key] = str + "";
				} else { };
			};
			pg1['1092002'] = 9020101; //设置subclassid为之前点击
			// pg1['loginPwd'] = this.loginPwd; //设置classid为之前点击
			// console.log(pg1);
			// console.log(pg1);
			// console.log(pg2);
			// console.log(pg3);
			console.log(pg1);
			axios.post('/pmdm/admin/userGroup/save', { //保存按钮
				"pageOne": pg1,
				"pageTwo": pg2,
				"pageThree": pg3
			})
				.then(res => {
					//console.log(res);
					if (res.data.code !== 200) {
						this.$message.error(res.data.message)
					} else if (res.data.code == 200) {
						this.$message({
							message: res.data.message,
							type: 'success'
						});
						this.reset();


						//this.$store.commit("setClassId", res.data.object.classId);
						//this.$store.commit("setObjID", res.data.object.id);
						//this.$store.commit("setSubClassId", res.data.object.subclassId);

						// this.$router.push("/UserGroupInfo");
					};
				})
				.catch(function (error) {
					console.log(error);
				});
		},

		CreateNext() {
			var vm = this;
			var pg1 = this.page_one_data;
			var pg2 = this.page_two_data;
			var pg3 = this.page_three_data;
			pg1.classId = this.classId_;


			var arr1 = this.page_one_data_select;
			var arr2 = this.page_two_data_select;
			var arr3 = this.page_three_data_select;

			var arr1_1 = this.page_one_data_select_1;
			var arr2_1 = this.page_two_data_select_1;
			var arr3_1 = this.page_three_data_select_1;


			for (var key in arr1) { //将下拉菜单输出格式s数组为对象
				var val = arr1[key];
				var str = "";
				for (var i = 0; i < val.length; i++) {
					str += val[i] + ";";
				};
				if (str.length > 0) {
					str = str.substr(0, str.length - 1);
				};
				if (str.length != 0) {
					pg1[key] = str + "";
				} else { };
			};
			for (var key in arr2) {
				var val = arr2[key];
				var str = "";
				for (var i = 0; i < val.length; i++) {
					str += val[i] + ";";
				};
				if (str.length > 0) {
					str = str.substr(0, str.length - 1);
				};
				if (str.length != 0) {
					pg2[key] = str + "";
				} else { };
			};
			for (var key in arr3) {
				var val = arr3[key];
				var str = "";
				for (var i = 0; i < val.length; i++) {
					str += val[i] + ";";
				};
				if (str.length > 0) {
					str = str.substr(0, str.length - 1);
				};
				if (str.length != 0) {
					pg3[key] = str + "";
				} else { };
			};
			for (var key in arr1_1) {
				var val = arr1_1[key];
				var str = "";
				for (var i = 0; i < val.length; i++) {
					str += val[i] + ";";
				};
				if (str.length > 0) {
					str = str.substr(0, str.length - 1);
				};
				if (str.length != 0) {
					pg1[key] = str + "";
				} else { };
			};
			for (var key in arr2_1) {
				var val = arr2_1[key];
				var str = "";
				for (var i = 0; i < val.length; i++) {
					str += val[i] + ";";
				};
				if (str.length > 0) {
					str = str.substr(0, str.length - 1);
				};
				if (str.length != 0) {
					pg2[key] = str + "";
				} else { };
			};
			for (var key in arr3_1) {
				var val = arr3_1[key];
				var str = "";
				for (var i = 0; i < val.length; i++) {
					str += val[i] + ";";
				};
				if (str.length > 0) {
					str = str.substr(0, str.length - 1);
				};
				if (str.length != 0) {
					pg3[key] = str + "";
				} else { };
			};
			pg1['1092002'] = 9020101; //设置subclassid为之前点击


			axios.post('/pmdm/admin/userGroup/save', { //保存按钮
				"pageOne": pg1,
				"pageTwo": pg2,
				"pageThree": pg3
			})
				.then(res => {
					//console.log(res);
					if (res.data.code != 200) {
						this.$message.error(res.data.message)
					} else if (res.data.code == 200) {
						this.$message({
							message: res.data.message,
							type: 'success'
						});

						this.reset();
						this.page_one_data_select[1092002] = this.pageInfo;
						this.$emit('buttonClick');


					};
				});
		},

		reset() {
			this.page_one_data = {};
			this.page_two_data = {};
			this.page_three_data = {};
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},

		async gitPartsList() {
			this.page_one = [];
			this.page_two = [];
			this.page_three = [];
			this.classId_ = 90201; //classId;
			//console.log(clsId);
			// this.classId = 9010101; //subclassId
			console.log(this.pageInfoObj);
			const {
				data: res
			} = await this.$http.get("/pmdm/admin/getTableColumnInfo/" + '9020101' + '/1');
			if (res.code !== 200)
				return this.$message.error(res.message);
			//console.log(Name);
			var data_1 = this.getNewData(res.object.columnInfo);

			//console.log(this.page_one);
			const {
				data: res2
			} = await this.$http.get("/pmdm/admin/getTableColumnInfo/9010101/2");
			var data_2 = this.getNewData(res2.object.columnInfo);

			const {
				data: res3
			} = await this.$http.get("/pmdm/admin/getTableColumnInfo/9010101/3");
			var data_3 = this.getNewData(res3.object.columnInfo);

			this.page_one = data_1;
			this.page_two = data_2;
			this.page_three = data_3;
			this.showTable = false;
			this.loading = false;
			this.page_one_data_select[1092002] = this.pageInfo
		}

	},
	created() {
		this.gitPartsList();
	}
};
</script>